import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { ModalFooter, ModalBody, ModalHeader, Modal, Button } from 'reactstrap';
import { performanceHeaderSubmit } from '../../../../store/apis/performanceService';

function PrevConfimation({ isOpen, toggle, headerData, refreshTable }) {
  const { mutate: headerSubmit, isPending } = useMutation({
    mutationFn: performanceHeaderSubmit,
    onSuccess: () => {
      toast.success('Submitted successfully!', {
        className: 'toast-success',
      });
      toggle();
      refreshTable();
    },
    onError: error => {
      toast.error(error?.message || 'Failed to submit data', {
        className: 'toast-error',
      });
    },
  });

  const handleYes = () => {
    let status = 'Define_Objectives';
    if (headerData.Manager_Review === 2) {
      status = 'Self_Assessment';
    } else if (headerData.Self_Assessment === 2) {
      status = 'Confirm_Objectives';
    } else if (headerData.Confirm_Objectives === 2) {
      status = 'Define_Objectives';
    } else if (headerData.Define_Objectives === 2) {
      status = 'Reset';
    } else {
      toast.error('You cannot go to the previous step at this stage.');
      toggle();
      return;
    }

    const payload = {
      employeeId: headerData?.EmpCd?.trim(),
      userId: '',
      status,
    };
    headerSubmit(payload);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="custom-modal-size"
      centered
    >
      <ModalHeader toggle={toggle}>Confirmation</ModalHeader>
      <ModalBody>Are you sure you want to move to the previous step?</ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={toggle}>
          No
        </Button>
        <Button
          className="item custom-btn"
          onClick={handleYes}
          disabled={isPending}
        >
          {isPending ? 'Wait..' : 'Yes'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PrevConfimation;
